import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Menu,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table, TableHead, TableRow, TableCell, TableBody, Link,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import {
    ClosedCaption, Download,
    MenuBook,
    MenuOpen,
    MenuOpenSharp,
    OpenInNew,
    OpenWith,
    OpenWithOutlined
} from "@mui/icons-material";
import {useGetStudentDetailsBySemesterQuery, useGetStudentSemestersQuery} from "../store/student/studentApi";
import PageTitle from "../components/PageTitle";
import {useUpdateStudentsExtraGrcPointsOfCourseMutation} from "../store/grc/grcApi";
import copyObject from "../utils/copyObject";

export default function StudentCardPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const roles = localStorage.getItem('roles').split(',');
    const isFaculty = roles.find((item) => item === 'faculty') !== undefined;
    const [selectedSemester, setSelectedSemester] = useState(null);
    const [selectedUserSemester, setUserSemester] = useState(localStorage.getItem("selectedSemesterId"));
    const [isLoading, setIsLoading] = useState(false);
    const data = null;
    const {data: semestersData} = useGetStudentSemestersQuery({studentId: id});
    const {data: studentData} = useGetStudentDetailsBySemesterQuery({
        studentId: id,
        semesterId: selectedSemester?.semesterId
    });
    const [copyOfStudentData, setCopyOfStudentData] = useState(null);
    const [grcDisciplines, setGrcDisciplines] = useState([]);
    const [extraGrcPoints, setExtraGrcPoints] = useState(null);
    const [saveGrcPointsRequest] = useUpdateStudentsExtraGrcPointsOfCourseMutation();
    const [extraGradeIsSaving, setExtraGradeIsSaving] = useState(false);
    const [reportIsDownloading, setReportIsDownloading] = useState(false);

    useEffect(() => {
        if ((selectedSemester === null || selectedSemester === undefined) && semestersData !== null && semestersData !== undefined) {

            const userSemesterInAvalaible = semestersData.semesters.findIndex(s => s.semesterId === Number(selectedUserSemester));

            if (userSemesterInAvalaible === -1) {
                setSelectedSemester(semestersData.semesters[0])
            } else {
                setSelectedSemester(semestersData.semesters[userSemesterInAvalaible])
            }
        }

        if (selectedSemester !== null && selectedSemester !== undefined) {
            // todo: load data
        }

        if (studentData) {
            const grcDisciplinesTemp = [];
            studentData.details?.grcDisciplines?.forEach((student) => {
                student.disciplines?.forEach((item) => {
                    if (item) {
                        grcDisciplinesTemp.push(item);
                    }
                })
            });

            setGrcDisciplines(grcDisciplinesTemp);
            setExtraGrcPoints(studentData.details?.extraGrcPoints ?? 0);
            setCopyOfStudentData(copyObject(studentData));
        }
    }, [selectedSemester, semestersData, studentData]);

    function getTotalGrcRating() {
        let sum = 0;
        grcDisciplines?.forEach((item) => {
            sum += item.rating;
        });

        return sum.toFixed(2);
    }

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function callApi(id) {
        setReportIsDownloading(true);
        fetch(`/Reports/GenerateStudentReportXlsx?studentId=${id}&fileType=xlsx`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    "semesterid": localStorage.getItem("selectedSemesterId")
                }
            }).then(response => {
            return response.blob();
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Отчет.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
            setReportIsDownloading(false);
        }).catch(error => { 
            console.log(error);
            alert('Ошибка');
            setReportIsDownloading(false);
        })
    }

    function toDateString(date) {
        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    function getSessionDetailElements(details) {
        return <>
            <TableCell>{details.controlType}</TableCell>
            <TableCell>{details.employees.join(', ')}</TableCell>
            <TableCell>
                <Link href={`/statementresults/${details.statementId}`}
                      target={"_blank"}>Ведомость №{details.statementNumber}</Link>
                {details.closingDate !== null
                    ? <small><br/> Закрыта {toDateString(details.closingDate)}</small>
                    : <small><br/> Открыта</small>}
            </TableCell>
            <TableCell>
                {details.grade}
            </TableCell>
        </>
    }

    function numbersOnly(input) {
        if (!input)
            return '';

        const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
        let result = '';
        input.split('').forEach((symbol, index) => {
            if (allowedSymbols.includes(symbol)) {
                result += symbol;
                // if (symbol === ',' || symbol === '.' && input.length === index + 1) {
                //     result += '0';
                // }
            }
        });

        result = result.replace(',', '.');

        return result;
    }
    
    async function saveExtraGrcPoints() {
        setExtraGradeIsSaving(true);
        await saveGrcPointsRequest({data: {
                semesterId: selectedSemester?.semesterId,
                students: [
                    {
                        studentId: parseInt(id.toString(), 10),
                        extraPoints: parseFloat(extraGrcPoints.toString())
                    }
                ]
            }}).unwrap()
            .then((response) => {
                setExtraGradeIsSaving(false);
                
                if (response.success) {
                    alert('Сохранено');
                } else {
                    response.errors.forEach((error) => {
                        alert(error);
                    });
                }
            })
            .catch((ex) => {
                alert('Ошибка');
                console.error(ex);
                setExtraGradeIsSaving(false);
            });
    }
    
    function sum(arr) {
        let temp = 0;
        arr.forEach((item) => {
            if (item)
                temp += item;
        });

        return temp;
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Карточка студента`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {studentData === null || studentData === undefined ? <CircularProgress/> : <></>}
                            Карточка студента - {studentData?.details?.fullName}
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2} direction={"row"} alignItems={"center"}>
                                <Typography>Семестр</Typography>
                                <Select size={"small"}
                                        fullWidth
                                        value={selectedSemester}
                                        onChange={(event) => setSelectedSemester(event.target.value)}
                                        placeholder={'Выберите семестр'}>
                                    {semestersData?.semesters.map((item) => {
                                        return <MenuItem value={item}
                                                         key={item.semesterName}>{item.semesterName}</MenuItem>
                                    })}
                                </Select>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography><strong>Факультет: </strong>{studentData?.details?.facultyName}</Typography>
                                <Typography><strong>ОПОП ВО: </strong>{studentData?.details?.educationProgramName}
                                </Typography>
                                <Typography><strong>Группа: </strong>{studentData?.details?.primaryGroupName}
                                </Typography>
                                <Typography><strong>Курс: </strong>{studentData?.details?.courseName}</Typography>
                                <Typography>
                                    <strong>Средний балл за весь период обучения: </strong>
                                    {studentData?.details?.totalAverageGrade}
                                </Typography>

                                {isFaculty
                                ? <Stack direction={"row"} spacing={2} alignItems={'center'}>
                                        <Typography>
                                            <strong>Дополнительные баллы БРС: </strong>
                                        </Typography>

                                        <TextField variant="outlined"
                                                   size={'small'}
                                                   value={extraGrcPoints}
                                                   onChange={(target) => {
                                                       const newValue = numbersOnly(target.target.value);
                                                       setExtraGrcPoints(parseFloat(newValue) > 15 ? 15 : newValue);
                                                   }}
                                                   placeholder="Баллы"/>

                                        <Button onClick={() => {saveExtraGrcPoints()}} 
                                                disabled={extraGradeIsSaving}
                                                startIcon={extraGradeIsSaving ? <CircularProgress size={15}/> : <></>}>Сохранить</Button>
                                    </Stack>
                                : <></>}

                                <Button onClick={() => callApi(id)}
                                        disabled={reportIsDownloading}
                                        startIcon={reportIsDownloading ? <CircularProgress size={15}/> : <Download />}
                                        sx={{alignSelf: 'flex-start', color: 'white'}} variant="contained">
                                    Скачать отчет
                                </Button>

                                {data?.data?.previousGroups.length > 0
                                    ? <Typography><strong>Предыдущие
                                        группы: </strong>{studentData?.details?.previousGroups.join(', ')}</Typography>
                                    : <></>}

                                {data?.data?.previousNames.length > 0
                                    ? <Typography><strong>Предыдущие
                                        имена: </strong>{studentData?.details?.previousNames.join(', ')}</Typography>
                                    : <></>}
                            </Stack>
                        </CardContent>
                    </Card>

                    {grcDisciplines && grcDisciplines.length > 0
                    ? <Card>
                            <Stack spacing={2}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<MenuOpen/>}>
                                        <Typography variant={"h6"}>БРС - {getTotalGrcRating()} баллов</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ol>
                                            {grcDisciplines?.map((item) => {
                                                const items = [];
                                                item.details.split('\n').forEach((det) => {
                                                    if (det && det.length > 2)
                                                        items.push(<li><Typography fontSize={'small'}>{det}</Typography>
                                                        </li>);
                                                });

                                                return items;
                                            })}
                                        </ol>
                                    </AccordionDetails>
                                </Accordion>
                            </Stack>
                        </Card>
                    : <></>}

                    <Card>
                        <Accordion>
                            <AccordionSummary expandIcon={<MenuOpen/>}>
                                <Typography variant={"h6"}>Дисциплины</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table size={"small"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Наименование</TableCell>
                                            <TableCell align={"center"}>Всего зачетных единиц/часов по дисциплине</TableCell>
                                            <TableCell>Пропущено часов (из них по уважительной причине / Не отмечено часов / Пройдено часов (суммарно) / Всего часов)</TableCell>
                                            <TableCell>Аттестация 1</TableCell>
                                            <TableCell>Аттестация 2</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {copyOfStudentData?.details?.disciplinesResults?.sort((l,r) => l.disciplineName > r.disciplineName ? 1 : -1).map((disc) => {
                                            return <TableRow>
                                                <TableCell>
                                                    <strong>{disc.disciplineName}</strong>
                                                    <br/>
                                                    <small>Кафедра {disc.chairName}</small>
                                                </TableCell>
                                                <TableCell align={"center"}>
                                                    {disc.checkpoints}/{sum(disc.lessonTypeDetails.map((ltd) => ltd.totalHours))}
                                                </TableCell>
                                                <TableCell>
                                                    <Table size={"small"} align={"left"}>
                                                        <TableBody>
                                                            {disc.lessonTypeDetails.length === 0
                                                                ? <TableRow>
                                                                    <TableCell>Лабораторная работа
                                                                        <br/>
                                                                        Не распределен(а) в подгруппу
                                                                    </TableCell>
                                                                </TableRow>
                                                                : <></>}
                                                            {disc.lessonTypeDetails.map((ltd) => {
                                                                return <TableRow>
                                                                    <TableCell>{ltd.lessonType}
                                                                        <br />
                                                                        <small>Преподаватель: {ltd.employeeName}</small>
                                                                        <br />
                                                                        <small>Пропущено {ltd.missedHours} ({ltd.missedHoursWithCertificate}/{ltd.totalHours - ltd.attendedHours - ltd.missedHours}/{ltd.attendedHours + ltd.missedHours}/{ltd.totalHours})</small>
                                                                    </TableCell>
                                                                </TableRow>
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                                <TableCell>
                                                    {disc.attestation1Grade !== null
                                                        ? `${disc.attestation1Grade}`
                                                        : ``}
                                                    <br/>
                                                    {disc.attestation1MissedHours !== null
                                                        ? <small>Пропущено часов: {disc.attestation1MissedHours}</small>
                                                        : <></>}
                                                </TableCell>
                                                <TableCell>
                                                    {disc.attestation2Grade !== null
                                                        ? `${disc.attestation2Grade}`
                                                        : ``}
                                                    <br/>
                                                    {disc.attestation2MissedHours !== null
                                                        ? <small>Пропущено часов: {disc.attestation2MissedHours}</small>
                                                        : <></>}
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>

                                <br/>
                                {studentData?.details?.disciplinesMissedHoursSum !== null && studentData?.details?.disciplinesMissedHoursSum !== undefined
                                    ? <Typography fontSize={'small'}><strong>Всего
                                        пропущено:</strong> {studentData.details.disciplinesMissedHoursSum}
                                    </Typography>
                                    : <></>}

                                {studentData?.details?.disciplinesTotalHoursSum !== null && studentData?.details?.disciplinesTotalHoursSum !== undefined
                                    ? <Typography fontSize={'small'}><strong>Всего
                                        часов:</strong> {studentData.details.disciplinesTotalHoursSum}
                                    </Typography>
                                    : <></>}
                            </AccordionDetails>
                        </Accordion>
                    </Card>

                    <Card>
                        <Accordion>
                            <AccordionSummary expandIcon={<MenuOpen/>}>
                                <Typography variant={"h6"}>Сессия</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table size={"small"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Дисциплина</TableCell>
                                            <TableCell>Тип контроля</TableCell>
                                            <TableCell>Преподаватели</TableCell>
                                            <TableCell>Ведомость</TableCell>
                                            <TableCell>Оценка</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {studentData?.details?.sessionDetails?.map((disc, discIndex) => {
                                            return <>
                                                <TableRow>
                                                    <TableCell rowSpan={disc?.detailsByControlType?.length ?? 1}>
                                                        <strong>{disc.disciplineName}</strong>
                                                    </TableCell>
                                                    {disc?.detailsByControlType.map((details, index) => {
                                                        if (index >= 1)
                                                            return null;

                                                        return getSessionDetailElements(details)
                                                    })}
                                                </TableRow>

                                                {disc?.detailsByControlType.map((details, index) => {
                                                    if (index < 1)
                                                        return null;

                                                    return <TableRow>
                                                        {getSessionDetailElements(details)}
                                                    </TableRow>
                                                })}
                                            </>
                                        })}
                                    </TableBody>
                                </Table>
                                <br/>
                                {studentData?.details?.averageSessionGradeBySemester !== null && studentData?.details?.averageSessionGradeBySemester !== undefined
                                    ? <Typography fontSize={'small'}>
                                        <strong>Средняя оценка по сессии за семестр:</strong> 
                                        {` ${studentData.details.averageSessionGradeBySemester}`}
                                    </Typography>
                                    : <></>}

                                {studentData?.details?.averageSessionGradeByYear !== null && studentData?.details?.averageSessionGradeByYear !== undefined
                                    ? <Typography fontSize={'small'}>
                                        <strong>Средняя оценка по сессии за год:</strong>
                                        {` ${studentData.details.averageSessionGradeByYear}`}</Typography>
                                    : <></>}
                            </AccordionDetails>
                        </Accordion>
                    </Card>

                    <Card>
                        <Accordion>
                            <AccordionSummary expandIcon={<MenuOpen/>}>
                                <Typography variant={"h6"}>Практика</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table size={"small"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Вид, тип практики</TableCell>
                                            <TableCell>Тип контроля</TableCell>
                                            <TableCell>Преподаватели</TableCell>
                                            <TableCell>Ведомость</TableCell>
                                            <TableCell>Оценка</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {studentData?.details?.practiceDetails?.map((disc) => {
                                            return <TableRow>
                                                <TableCell>
                                                    <strong>
                                                        {disc.practiceType}<br/>
                                                        {disc.practiceKind === 1 ? 'Учебная' : 'Производственная'}
                                                    </strong>
                                                </TableCell>
                                                <TableCell>{disc.controlType === 1 ? 'Зачёт' : 'Зачёт с оценкой'}</TableCell>
                                                <TableCell>{disc.employees.join(', ')}</TableCell>
                                                <TableCell>
                                                    <Link href={`/practice-statement-results/${disc.statementId}`}
                                                          target={"_blank"}>Ведомость №{disc.statementNumber}</Link>
                                                    {disc.closingDate !== null
                                                        ? <><br/> Закрыта {toDateString(disc.closingDate)}</>
                                                        : <><br/> Открыта</>}
                                                </TableCell>
                                                <TableCell>
                                                    {disc.gradeName}
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </AccordionDetails>
                        </Accordion>
                    </Card>

                    <Card>
                        <Accordion>
                            <AccordionSummary expandIcon={<MenuOpen/>}>
                                <Typography variant={"h6"}>Документы</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table size={"small"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Наименование</TableCell>
                                            <TableCell>Файл</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {studentData?.details?.documents?.map((doc) => {
                                            return <TableRow>
                                                <TableCell>{doc.documentName}</TableCell>
                                                <TableCell>
                                                    {doc.fileGuid !== null && doc.fileGuid !== undefined
                                                        ? <Button href={`https://fs.kubsau.ru/File/${doc.fileGuid}`}
                                                                  startIcon={<Download/>}
                                                                  target={'_blank'}>Скачать</Button>
                                                        : <></>}
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </AccordionDetails>
                        </Accordion>
                    </Card>

                    <Typography fontSize={'small'}>* Для расчета средней оценки по сессии за семестр берутся оценки от 2
                        до 5 по закрытым ведомостям</Typography>
                    <Typography fontSize={'small'}>** Для расчета средней оценки по сессиям за год берутся оценки от 2
                        до 5 по закрытым ведомостям, после чего группируются по типу сдачи. Если в первом семестре по
                        предмету был зачёт, а во втором семестре экзамен, то для расчета будет браться экзаменационная
                        оценка</Typography>
                    <Typography fontSize={'small'}>*** Для расчета средней оценки за весь период обучения берутся оценки
                        от 2 до 5 по сессиям, после чего группируются по типу сдачи. Если в первом семестре по предмету
                        был зачёт, а во втором семестре экзамен, то для расчета будет браться экзаменационная оценка.
                        Далее этот список оценок объединяется с оценками по практикам, после чего вычисляется средний
                        балл по формуле - <em>"(ср. балл за все сессии + ср. балл за все практики) / 2"</em>. Если для
                        студента не найдено ни одной оценки по практике, то считается средний балл лишь по
                        сессиям</Typography>

                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}